// define app version
const Version = require("../version.json")

const WebVersion = Version.webVersion
const AndroidVersion = Version.androidVersion
const IosVersion = Version.iosVersion

export { WebVersion, AndroidVersion, IosVersion }
export default Version
